// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GreetingCard__container-ea91f0 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.GreetingCard__inner-container-b1fa72 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.GreetingCard__card-c5453e {
  width: 100%;
  max-width: 440px;
}

.GreetingCard__card-img-add929 {
  width: 100%;
}

.GreetingCard__caption-c42a43 {
  font: var(--font-title-9);
  text-align: center;
  line-height: 32px;
  letter-spacing: var(--font-spacing-title-9);
  margin-top: 32px;
  padding: 0 10px;
  color: var(--base-110);
}

.GreetingCard__reply-btn-d0fe14 {
  margin: 24px auto;
  display: block;
}

.GreetingCard__not-found-d1db01 {
  height: calc(100vh - 73px);
}`, "",{"version":3,"sources":["webpack://./src/GreetingCard/GreetingCard.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,0BAAA;AACF","sourcesContent":[".container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.inner-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card {\n  width: 100%;\n  max-width: 440px;\n}\n\n.card-img {\n  width: 100%;\n}\n\n.caption {\n  font: var(--font-title-9);\n  text-align: center;\n  line-height: 32px;\n  letter-spacing: var(--font-spacing-title-9);\n  margin-top: 32px;\n  padding: 0 10px;\n  color: var(--base-110);\n}\n\n.reply-btn {\n  margin: 24px auto;\n  display: block;\n}\n\n.not-found {\n  height: calc(100vh - 73px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GreetingCard__container-ea91f0`,
	"inner-container": `GreetingCard__inner-container-b1fa72`,
	"innerContainer": `GreetingCard__inner-container-b1fa72`,
	"card": `GreetingCard__card-c5453e`,
	"card-img": `GreetingCard__card-img-add929`,
	"cardImg": `GreetingCard__card-img-add929`,
	"caption": `GreetingCard__caption-c42a43`,
	"reply-btn": `GreetingCard__reply-btn-d0fe14`,
	"replyBtn": `GreetingCard__reply-btn-d0fe14`,
	"not-found": `GreetingCard__not-found-d1db01`,
	"notFound": `GreetingCard__not-found-d1db01`
};
module.exports = ___CSS_LOADER_EXPORT___;
